// ---- LAYER EXTENSION SEAM (frontend) ----------------------------------------
// This file is LAYER-OWNED: in a rented-kit deployment the customer's layer
// repo overlays it (see docs/layer-contract.md). The kit ships empty exports
// so a bare kit builds identically with or without a layer.
//
// Contract (keep shapes stable — App.js / Navbar map these blindly):
//   extRoutes: [{ path, element, public?: boolean }]
//     Mounted inside the kit's <Routes>. Non-public routes are wrapped in
//     the kit's RequireAuth. Keep paths under /ext/… or your own product
//     namespace — never shadow kit routes (/, /login, /dev, /jobs, /items).
//   extNav: [{ to, label }]
//     Extra links appended to the kit Navbar for signed-in members.

import React from 'react';
import { Navigate } from 'react-router-dom';
import Today from './Today';
import Library from './Library';
import Teach from './Teach';
import Membership from './Membership';
import Profile from './Profile';
import PracticePlayer from './PracticePlayer';
import PlanGate from './PlanGate';
import { syncInternalNav } from './syncInternalNav';
import { ensureYogaSite } from './ensureYogaSite';
import { initTheme } from './yogaTheme';
import './yogaTheme.css';

if (typeof document !== 'undefined') {
  initTheme();
  syncInternalNav();
  ensureYogaSite();
}

function Gate({ children }) {
  return <PlanGate>{children}</PlanGate>;
}

export const extRoutes = [
  { path: '/today', element: <Gate><Today /></Gate> },
  { path: '/library', element: <Gate><Library /></Gate> },
  { path: '/teach', element: <Gate><Teach /></Gate> },
  { path: '/membership', element: <Membership /> },
  { path: '/profile', element: <Gate><Profile /></Gate> },
  { path: '/practice/:lessonId', element: <PracticePlayer /> },

  // Legacy bookmarks
  { path: '/home', element: <Navigate to="/today" replace /> },
  { path: '/lessons', element: <Navigate to="/library" replace /> },
  { path: '/poses', element: <Navigate to={{ pathname: '/library', search: '?tab=poses' }} replace /> },
  { path: '/account', element: <Navigate to="/membership" replace /> },
];

export const extNav = [
  { to: '/today', label: 'Today' },
  { to: '/library', label: 'Library' },
  { to: '/teach', label: 'Teach' },
  { to: '/membership', label: 'Membership' },
  { to: '/profile', label: 'Profile' },
];
